<template>
  <confirm-dialog
    :title="removalConfirmationTitle"
    ref="removeDialog"
    @ok="removeCustomField"
    @hidden="$emit('hidden')"
    ok-variant="danger"
    :ok-title="customField && customField.projectId ? 'Delete' : 'Remove'"
    cancel-title="No, I changed my mind"
    hide-header-close
  >
    <div v-if="customField">
      <div v-if="!!customField.projectId">
        Removing the custom field "<b>{{ customField.name }}</b
        >" will permanently delete the custom field and remove its values from all initiatives in
        this project. This cannot be undone.
      </div>
      <div v-else>
        This will remove the custom field "<b>{{ customField && customField.name }}</b
        >" from the {{ teamSpaceName }} "<b>{{ team.name }}</b
        >". Field values will still remain on individual tasks, but will not be editable. You can
        always add this field back from the library
      </div>
    </div>
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import service from '@/service'
import urlManager from '@/urlManager'
import getTeamSpaceName from '@/utils/getTeamSpaceName'
import showAPIError from '@/utils/showAPIError'
import showToast from '@/utils/showToast'
import { mapActions } from 'vuex'

/**
 * This provides a confirmation dialog that gets triggered while removing a custom field from a team/project.
 * The dialog can be shown by calling function - show
 */
export default {
  name: 'RemoveCustomFieldConfirmDialog',
  components: { ConfirmDialog },
  props: ['orgId', 'teamId', 'projectId', 'customField'],
  computed: {
    team() {
      return this.$store.getters.teamById(this.teamId)
    },
    teamSpaceName() {
      if (this.projectId) {
        return 'Project'
      }
      return getTeamSpaceName(this.team)
    },
    removalConfirmationTitle() {
      return `Remove custom field from ${this.teamSpaceName}`
    }
  },
  methods: {
    ...mapActions(['detachCustomField']),
    show() {
      this.$refs.removeDialog.show()
    },
    deleteCustomField() {
      return service.client.delete(
        urlManager.CFDefinitionsDetail({
          orgId: this.orgId,
          customFieldId: this.customField.id
        })
      )
    },
    async removeCustomField() {
      try {
        if (this.customField.projectId) {
          await this.deleteCustomField()
        } else {
          await this.detachCustomField({
            orgId: this.orgId,
            enabledFieldId: this.customField.enabledFieldId
          })
        }
        showToast('Custom field has been removed successfully')
        this.$emit('removed')
      } catch (e) {
        showAPIError(e)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
